import { forwardRef, createElement } from 'react';

function IconRotateLeft(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M12 2.75a9.25 9.25 0 016.54 15.79.75.75 0 11-1.06-1.06 7.75 7.75 0 10-13.224-5.797l.714-.713.084-.073a.75.75 0 011.049 1.05l-.073.083-2 2-.084.073a.75.75 0 01-.882.007l-.094-.08-2-2-.073-.084a.75.75 0 01-.007-.882l.08-.094.084-.073a.75.75 0 01.882-.007l.094.08.725.724A9.25 9.25 0 0112 2.75z",
    fill: "currentColor"
  }));
}

var RotateLeft = /*#__PURE__*/forwardRef(IconRotateLeft);

export default RotateLeft;
//# sourceMappingURL=RotateLeft.js.map
